export default class DatePeriodModel {
  StartDate: Date = null;
  EndDate: Date = null;

  constructor(obj?: Partial<DatePeriodModel>) {
    if (obj) {
      Object.assign(this, obj)
    }
  }
}